export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Embedded Termly Content */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          <iframe
            src="https://app.termly.io/policy-viewer/policy.html?policyUUID=347ef56d-42cd-4fa8-aeaf-e34bf9128641"
            className="w-full border-0"
            style={{ minHeight: '100vh' }}
            title="Terms of Service"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          />
        </div>
      </div>
    </div>
  )
}
